import { SubscriptionFeature } from "../../types/billing/SubscriptionFeature";

export const cloImApRequiredFeatures = [
    SubscriptionFeature.DealerProfileEmailAlerts,
    SubscriptionFeature.IssuanceMonitorFullAccess,
]